import { getNames, type LocaleData, registerLocale } from "i18n-iso-countries";
import enLocale from "i18n-iso-countries/langs/en.json";

registerLocale(enLocale as unknown as LocaleData);

export interface CountryOption {
  code: string;
  name: string;
}

export const COUNTRIES: CountryOption[] = Object.entries(getNames("en", { select: "official" }))
  .map(([code, name]) => ({ code, name }))
  .sort((a, b) => a.name.localeCompare(b.name));
